import { Marker } from '@/types';

export function sortMarkersByDistanceFromCenter(
  center: google.maps.LatLngLiteral,
  markers: Marker[]
): Marker[] {
  if (!center || !markers.length || !google.maps?.geometry?.spherical)
    return [];
  const sortedMarkers = markers.sort((a, b) => {
    const aDistance = google.maps.geometry.spherical.computeDistanceBetween(
      { lat: center.lat, lng: center.lng },
      a.coords
    );
    const bDistance = google.maps.geometry.spherical.computeDistanceBetween(
      { lat: center.lat, lng: center.lng },
      b.coords
    );
    return aDistance - bDistance;
  });
  return sortedMarkers;
}
